import { AuthService } from '@auth0/auth0-angular';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { tap } from 'rxjs';

import { CookiesService } from './cookies.service';
import { EventsService } from './events.service';
import { AITRUS_TOKEN } from './aitrus-sso.service';

@Injectable({
  providedIn: 'root'
})
export class BaseAuthService {

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private cookiesService: CookiesService,
    private eventService: EventsService,
    private auth0: AuthService
  ) { }

  monitorAuthenticationStatus(): void {
    this.auth0.idTokenClaims$.pipe(
      tap((response) => {
        if (response?.exp) {
          this.checkAndRenewToken(response.exp);
        }
      })
    ).subscribe();
  }

  checkAndRenewToken(expiryTimestamp: number): void {
    const isTokenExpired: boolean = this.isTokenExpired(expiryTimestamp);

    if (isTokenExpired) {
      this.cookiesService.removeItem('TOKEN', '/');
      this.cookiesService.removeItem('TOKEN');
      this.cookiesService.clearCookies();
      this.auth0.logout();
    }
  }

  // private renewToken(): void {
  //   this.auth0.getAccessTokenSilently().pipe(
  //     tap((token) => {
  //       this.cookiesService.setItem('TOKEN', token);
  //     })
  //   ).subscribe();
  // }

  private isTokenExpired(expirationTime: number): boolean {
    const decodedToken: number = expirationTime
    const currentTime = Math.floor(Date.now() / 1000);
    return decodedToken < currentTime;
  }

  logout(): void {
    this.cookiesService.removeItem('TOKEN', '/');
    this.cookiesService.removeItem('TOKEN');
    // O clearCookies() abaixo já é um deleteAll, mas o token da Aitrus sai nomeado:
    // é uma credencial de outro sistema, e a remoção explícita é o que se verifica.
    this.cookiesService.removeItem(AITRUS_TOKEN);
    this.cookiesService.clearCookies();
    localStorage.removeItem('CNPJ');
    localStorage.removeItem('CNPJ_NAME');
    localStorage.removeItem('PENDENCIAS-ONBOARD');
    localStorage.removeItem('savedHref');
    localStorage.removeItem('savedLocation');
    localStorage.removeItem('utm_params');
    this.eventService.rudderAnalytics?.reset();

    this.auth0.logout({
      logoutParams: {
        returnTo: this.document.location.origin
      }
    });
  }
}
